

























































import { Component, Vue } from 'vue-property-decorator';
import { Container, Draggable } from 'vue-smooth-dnd';
import Footer from '@/components/Footer.vue';
import CarService from '@/services/car';
import CarTile from '@/components/CarTile.vue';
import Loader from '@/components/Loader.vue';
import LoadableContainer from '@/components/LoadableContainer.vue';
import Car from '@/entities/Car';
import Icon from '@/components/Icon.vue';

@Component({
  components: {
    Icon,
    LoadableContainer,
    Loader,
    Footer,
    CarTile,
    Container,
    Draggable,
  },
})
export default class Cars extends Vue {
  carService = new CarService();

  carToRemove: Car = null;

  orderChanged = false;

  get cars() {
    return this.carService.list;
  }

  goToCar(car: Car) {
    this.$router.push({
      name: 'Car',
      params: {
        id: car.id,
      },
    });
  }

  remove() {
    this.carService.delete(this.carToRemove);
  }

  onDrop(dropResult: any) {
    const { removedIndex, addedIndex } = dropResult;
    if (removedIndex !== addedIndex) {
      this.orderChanged = true;
      this.carService.move(removedIndex, addedIndex);
    }
  }

  saveOrder() {
    this.carService.saveOrder(this.cars)
      .then(() => {
        this.orderChanged = false;
      });
  }
}
